
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const AutoLogout = () => {
  const navigate = useNavigate();
  let logoutTimer;

  const resetTimer = () => {
    clearTimeout(logoutTimer);
    logoutTimer = setTimeout(logout, 15* 60 * 1000); 
  };

  const logout = () => {
    // Clear all local session data
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("userData");
    // Redirect to login page
    navigate("/");
  };

  useEffect(() => {
    // Events that indicate user activity
    const events = [
      'mousemove', 
      'keydown', 
      'mousedown', 
      'touchstart',
      'scroll',
      'click'
    ];

    // Add event listeners
    events.forEach(event => window.addEventListener(event, resetTimer));

    // Start the timer on initial load
    resetTimer();

    // Cleanup function
    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(logoutTimer);
    };
  }, []);

  return null;
};

export default AutoLogout;